import React, {Component} from 'react';
import {connect} from "react-redux";
import {NewsActions} from "../../actions/news.actions";
import NewsForm from "./NewsForm";
import {reset} from 'redux-form';
import Card, {CardActions, CardContent} from 'material-ui/Card';
import {Button, Paper, Typography} from "material-ui";
import ReactMarkdown from 'react-markdown';
import moment from 'moment';
import {withStyles} from 'material-ui/styles';
import Dialog, {DialogTitle, DialogContent, DialogActions} from 'material-ui/Dialog';
import Slide from 'material-ui/transitions/Slide';
import fire from "../../conf/initFirebase";
import {submit} from 'redux-form';
import ReactGA from 'react-ga';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({

    card: {
        marginBottom: 16
    },
    subTitle: {
        marginBottom: 16,
        fontSize: 14,
        color: theme.palette.text.secondary,
    }
});

class Home extends Component {

    constructor(props) {
        super(props);
        this.editRef = fire.database();
    }

    state = {
        dialogPost: undefined,
        dialogAction: undefined
    };


    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
        this.props.dispatch(NewsActions.fetch());
    }

    handleSubmitNews = (values) => {
        this.props.dispatch(NewsActions.add(values, this.resetForm));
    };

    resetForm = () => {
        this.props.dispatch(reset('newsForm'));
        this.handleClose();
    };

    isAdmin = () => {
        const {user} = this.props;
        return user && user.isAdmin;
    };

    renderNews = () => {
        const {news, classes, user} = this.props;
        return news.map((n, i) => {
            return (
                <Card key={i} className={classes.card}>
                    <CardContent>
                        <Typography variant="headline" component="h2">
                            {n.title}
                        </Typography>
                        <Typography className={classes.subTitle}>
                            {moment(n.created_at).format('dddd DD MMMM YYYY, h:mm')}
                        </Typography>
                        <ReactMarkdown
                            source={n.content}
                        />
                    </CardContent>
                    {this.isAdmin() &&
                    <CardActions>
                        <Button variant="raised" color="primary" onClick={() => this.handleActions(n, 'EDIT')}>
                            Modifier
                        </Button>
                        <Button variant="raised" color="primary" onClick={() => this.handleActions(n, 'DELETE')}>
                            Supprimer
                        </Button>
                    </CardActions>
                    }
                </Card>
            )
        })
    };

    handleActions = (newsToEdit, action) => {
        this.setState({
            dialogPost: newsToEdit,
            dialogAction: action
        });
    };

    handleClose = () => {
        this.setState({
            dialogPost: undefined,
            dialogAction: undefined
        });
    };

    deleteNews = () => {
        this.editRef.ref('news/' + this.state.dialogPost.id).remove().then(data => {
            this.handleClose();
        })
    };

    renderActionTitle = () => {
        switch (this.state.dialogAction) {
            case 'EDIT':
                return 'Editer l\'article';
            case 'CREATE':
                return 'Ajouter un article';
            case 'DELETE':
                return 'Supprimer l\'article';
            default:
                return '';
        }
    };

    renderActionContent = () => {
        switch (this.state.dialogAction) {
            case 'EDIT':
                return (
                    <NewsForm
                        initialValues={this.state.dialogPost}
                        onSubmit={this.submitEdit}
                    />
                );
            case 'DELETE':
                return (
                    <div>
                        <p>Confirmer la suppression</p>
                    </div>
                );
            case 'CREATE':
                return (
                    <NewsForm
                        onSubmit={this.handleSubmitNews}
                    />
                );
            default:
                return '';
        }
    };

    renderActions = () => {
        switch (this.state.dialogAction) {
            case 'EDIT':
                return (
                    <div>
                        <Button color="primary" onClick={() => this.handleClose()}>
                            Annuler
                        </Button>
                        <Button variant="raised" color="primary" onClick={() => this.submitRemoteEdit()}>
                            Sauvegarder
                        </Button>
                    </div>
                );
            case 'DELETE':
                return (
                    <div>
                        <Button color="primary" onClick={() => this.handleClose()}>
                            Annuler
                        </Button>
                        <Button variant="raised" color="primary" onClick={() => this.deleteNews()}>
                            Confirmer
                        </Button>
                    </div>
                );
            case 'CREATE':
                return (
                    <div>
                        <Button color="primary" onClick={() => this.handleClose()}>
                            Annuler
                        </Button>
                        <Button variant="raised" color="primary" onClick={() => this.submitRemoteEdit()}>
                            Sauvegarder
                        </Button>
                    </div>
                );
            default:
                return '';
        }
    };

    submitRemoteEdit = () => {
        this.props.dispatch(submit('newsForm'));
    };

    submitEdit = (values) => {
        this.editRef.ref('news/' + values.id).update(values).then(data => {
            this.handleClose();
        }).catch(error => {
            console.log("error => ", error);
        })
    };

    render() {
        const {user} = this.props;
        return (
            <div>
                {(user && user.isAdmin) &&
                <div>
                    <Button variant="raised" color="primary" onClick={() => this.handleActions(undefined, 'CREATE')}>
                        Ajouter un article
                    </Button>
                </div>
                }
                <h1>Dernières nouveautés</h1>
                <div>
                    {this.renderNews()}
                </div>

                <Dialog
                    open={this.state.dialogAction !== undefined}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    transition={Transition}
                    keepMounted
                    onClose={this.handleClose}
                >
                    <DialogTitle>
                        {this.renderActionTitle()}
                    </DialogTitle>
                    <DialogContent>
                        {this.renderActionContent()}
                    </DialogContent>
                    <DialogActions>
                        {this.renderActions()}
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const state2props = state => ({
    user: state.User.user,
    fetchNews: state.News.fetchNews,
    news: state.News.news
});

export default connect(state2props)(withStyles(styles)(Home));


// WEBPACK FOOTER //
// ./src/pages/home/Home.js